/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".target_24423f1a{display:block}.host_24423f1a{position:absolute;left:0;right:0;bottom:0;top:0;pointer-events:none}\n"}]);
export const target = "target_24423f1a";
export const host = "host_24423f1a";